import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const ResiduoPatogenicoSchema = yup.object().shape({
  orden: yup.number().optional().nullable().default(null),
  descripcion: yup
    .string()
    .max(100, "errors.residuoPatogenico.descripcion.max")
    .required("errors.residuoPatogenico.descripcion.required")
    .default(""),
  cantidad: CantidadSchema.required(
    "errors.residuoPatogenico.cantidad.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "KG" } }),
  operacionesUnitarias: yup
    .array()
    .min(1, "errors.residuoPatogenico.operacionesUnitarias.min")
    .required("errors.residuoPatogenico.operacionesUnitarias.required")
    .default([]),
});
